export interface InspectionDetail {
    title: string;
    value: string;
}

export function getFormattedDetails(data: any, t: any) {
    let inspectionDate = t("unknown");

    if (data.InspectionStart !== null) {
        if (data.InspectionEnd === null) {
            const dt = new Date(data.InspectionStart);
            inspectionDate = dt.toLocaleDateString(t("locale"), {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        } else {
            const dtStart = new Date(data.InspectionStart);
            const dtEnd = new Date(data.InspectionEnd);
            if (dtEnd <= dtStart) {
                inspectionDate = dtStart.toLocaleDateString(t("locale"), {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                });
            } else {
                inspectionDate =
                    dtStart.toLocaleDateString(t("locale"), {
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                    }) +
                    " - " +
                    dtEnd.toLocaleDateString(t("locale"), {
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                    });
            }
        }
    }

    return [
        {
            title: t("inspection.details.inspection_id"),
            value: data.InspectionNumber
        },
        {
            title: t("inspection.details.vessel_name"),
            value: data.ShipName
        },
        {
            title: t("inspection.details.imo_number"),
            value: data.ShipIMO
        },
        {
            title: t("inspection.details.inspection_date"),
            value: inspectionDate
        },
        {
            title: t("inspection.details.inspection_location"),
            value: data.InspectionLocation
        }
    ];
}
